module.exports = __webpack_public_path__ + "img/revoke-ticket-icon.ecc44980.svg";